module.exports = __webpack_public_path__ + "static/media/other.f1d632ef.jpg";